<template>
  <div class="wrapper-table">
    <div style="margin-bottom: 4px" class="flex bold vertical-center">
      <div style="font-size: 14px; font-weight: 500; margin-right: 2px;">{{formatNum(formatNumber(itemsData.value))}}</div>
      <div style="color: #8F9CAC; text-align: right"> &nbsp;{{formatNum(getFormatCountWithoutPlus(itemsData.share))}}</div>
    </div>
    <div class="flex vertical-center ">
      <div class="wrapper-table__badge bold" :style="getColor(itemsData.delta_value)">
        <div style="text-align: center" class=" ">
          {{formatNum(getFormatCount(itemsData.delta_value, true))}}
        </div>
      </div>
      <div style="color: #8F9CAC; font-weight: 500; margin-left: 2px;"> &nbsp;{{formatNum(getFormatCount(itemsData.delta_percent))}}</div>
    </div>
  </div>
</template>
<script setup>
import {formatNum, getFormatCount, getFormatCountWithoutPlus} from "@/utils";

const props = defineProps({
  items: [Object, Array],
})
const itemsData = {
  value: props.items.value,
  share: props.items.share,
  delta_value: props.items.delta_value,
  delta_percent: props.items.delta_percent,
}
const getColor = (item, index) => {
  if (index === 0) return
  if (typeof item === 'string') {
    return item.includes('-') ? 'background:#DD4646!important;' : 'background:#26A659!important;'
  } else {
    return item < 0 ? 'background:#DD4646!important;' : 'background:#26A659!important;'
  }
}

const formatNumber = (num) => {
  // Преобразуем в число, если передана строка
  const number = typeof num === 'string' ? parseFloat(num.replace(/\s+/g, '')) : num;

  // Проверяем, что это действительное число
  if (isNaN(number)) return num.toString();

  // Форматируем с разделителями
  return number.toLocaleString('ru-RU', {
    maximumFractionDigits: 20 // Чтобы не округляло десятичные дроби
  }).replace(/,/g, ' '); // Заменяем запятые на пробелы (по русскому стандарту)
}

</script>
<style scoped lang="scss">
.wrapper-table {

  font-size: 12px;
  &__badge {
    //width: 38px;
    height: 15px;
    padding: 0 4px;
    font-weight: 600;
    color: white;
    border-radius: 4px;
  }
}
</style>